export const BidsListFtlColumns = [
    {
        name: 'Номер',
        key: 'id',
    },
    {
        name: 'Номер заказа FTL',
        key: 'ftlOrderId',
    },
    // {
    //     name: 'Номер заявки FTL',
    //     key: 'ftlBidId',
    // },
    {
        name: 'Маршрут',
        key: 'route',
    },
    {
        name: 'Перевозчик',
        key: 'carrier',
    },
    {
        name: 'Создатель',
        key: 'user',
    },
    {
        name: 'Дата и время создания',
        key: 'createdAt',
    },
    {
        name: 'Статус',
        key: 'status',
    },
]

export const BidsListColumns = [
    {
        name: 'Номер',
        key: 'id',
    },
    {
        name: 'Маршрут',
        key: 'route',
    },
    {
        name: 'Перевозчик',
        key: 'carrier',
    },
    {
        name: 'Создатель',
        key: 'user',
    },
    {
        name: 'Дата и время создания',
        key: 'createdAt',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: 'Стоимость перевозки',
        key: 'costOfTransportation',
    },
    {
        name: 'Норма себестоимости',
        key: 'costStandard',
    },
    {
        key: 'isProject',
        name: 'Проект',
    },
]

export const BidsWaitListColumns = [
    {
        name: 'Номер',
        key: 'id',
    },
    {
        name: 'БИН',
        key: 'bin',
    },
    {
        name: 'Компания',
        key: 'companyName',
        withHint: true,
    },
    {
        name: 'Подписи',
        key: 'signers',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
]
